export const setURLParams = (params) => {
  if (params.length <= 0) return '';
  try {
    return `?${params
      .map(
        (param) => `${Object.keys(param)[0]}=${param[Object.keys(param)[0]]}`
      )
      .join('&')}`;
  } catch {
    return '';
  }
};
